import { Switch } from '@sravni/react-design-system';

import styles from './styles.module.scss';

interface AuthSwitchProps {
    onClick: () => void;
}

export const AuthSwitch: React.FC<AuthSwitchProps> = ({ onClick }: AuthSwitchProps) => (
    <Switch checked={false} className={styles.switch} onClick={onClick}>
        Хочу первый займ под 0%
    </Switch>
);
